import { downloadFile, hasError } from "@/utils/utils";
import TransactionsService from "../../services";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import dayjs from "dayjs";
export default {
  namespaced: true,
  state: {
    loading: false,
    Transaction: {},
    TransactionType: [],
    OrgInformation: {},
    JobTitles : [] ,
    TransactionDesc : {} ,
    loadingFetchTransactionDesc: false,
    loadingFetchTransactionDesc: false,
    loadingFetchOrgInformation: false,
    ifCanConsecutiveSubmission : false,
    loadingcheckConsecutiveSubmission : false ,
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    Transaction(state) {
      return state.Transaction;
    },
    OrgInformation(state) {
      return state.OrgInformation;
    },
    TransactionType(state) {
      return state.TransactionType;
    },
    JobTitles(state) {
      return state.JobTitles;
    },
    TransactionDesc(state) {
      return state.TransactionDesc;
    },
    loadingFetchTransactionDesc(state) {
      return state.loadingFetchTransactionDesc;
    },
    loadingTransactionType(state) {
      return state.loadingTransactionType;
    },
    loadingFetchOrgInformation(state) {
      return state.loadingFetchOrgInformation;
    },
    ifCanConsecutiveSubmission(state){
      return state.ifCanConsecutiveSubmission;
    },
    loadingcheckConsecutiveSubmission(state){
      return state.loadingcheckConsecutiveSubmission;
    },
    
  },
  mutations: {
    setLoading(state, payload) {
      state.loading = payload;
    },
    setTransaction(state, payload) {
      state.Transaction = payload;
    },
    setOrgInformation(state, payload) {
      state.OrgInformation = payload;
    },
    setTransactionType(state, payload) {
      state.TransactionType = payload;
    },
    setJobTitles(state, payload) {
      state.JobTitles = payload;
    },
    setTransactionDesc(state, payload) {
      state.TransactionDesc = payload;
    },
    setLoadingFetchTransactionDesc(state, payload) {
      state.loadingFetchTransactionDesc = payload;
    },
    setLoadingTransactionType(state, payload) {
      state.loadingTransactionType = payload;
    },
    setLoadingFetchOrgInformation(state, payload) {
      state.loadingFetchOrgInformation = payload;
    },
    setIfCanConsecutiveSubmission(state, payload) {
      state.ifCanConsecutiveSubmission = payload;
    },
    setLoadingcheckConsecutiveSubmission(state, payload) {
      state.loadingcheckConsecutiveSubmission = payload;
    },
  },
  actions: {
    async fetchTransactioById({ commit }, payload) {
      commit("setLoading", true);
      try {
        const res = await TransactionsService.fetchTransactioById(payload);
        // dispatch("handleResponse", res);
        // if (hasError(res.status)) throw res.status;
        commit("setTransaction", res.data);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async fetchTransactionDesc({ commit }, payload) {
      commit("setLoadingFetchTransactionDesc", true);
      try {
        const res = await TransactionsService.fetchTransactionDesc(payload);
        commit("setTransactionDesc", res.data);
      } catch (err) {
      } finally {
        commit("setLoadingFetchTransactionDesc", false);
      }
    },
    async checkConsecutiveSubmission({ commit }, payload) {
      commit("setLoadingcheckConsecutiveSubmission", true);
      try {
        const res = await TransactionsService.checkConsecutiveSubmission(payload);
        commit("setIfCanConsecutiveSubmission", res.data.data);
      } catch (err) {
      } finally {
        commit("setLoadingcheckConsecutiveSubmission", false);
      }
    },
    async fetchOrgInformation({ commit }) {
      commit("setLoadingFetchOrgInformation", true);
      try {
        const res = await TransactionsService.fetchOrgInformation();
        commit("setOrgInformation", res.data);
      } catch (err) {
      } finally {
        commit("setLoadingFetchOrgInformation", false);
      }
    },
    async fetchTransactionType({ commit }) {
      commit("setLoadingTransactionType", true);
      try {
        const res = await TransactionsService.fetchTransactionType();
        commit("setTransactionType", res.data.data);
      } catch (err) {
      } finally {
        commit("setLoadingTransactionType", false);
      }
    },
    async fetchJobTitles({ commit }) {
      commit("setLoading", true);
      try {
        const res = await TransactionsService.fetchJobTitles();
        commit("setTransactionType", res.data.data);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async createTransactions({ commit, dispatch }, payload) {

      commit("setLoading", true);
      
      try {
        const res = await TransactionsService.createTransactions(payload);
        if (hasError(res.status)) {
          throw res.status;
        }
        
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت الإضافة بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
        return Promise.reject();
      } finally {
        commit("setLoading", false);
      }
    },
    async updateTransactions({ commit, dispatch }, payload) {
      console.log("payload" , payload)
      commit("setLoading", true);
      
      try {
        const res = await TransactionsService.updateTransactions(payload);
        if (hasError(res.status)) {
          throw res.status;
        }
        
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت التعديل بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
        return Promise.reject();
      } finally {
        commit("setLoading", false);
      }
    },

    handleResponse({ commit, dispatch }, res) {
      if (hasError(res.status)) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
          },
        });
      } else {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت العملية بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
      }
    },
  },
};
